__turbopack_context__.v({
  "container": "styles-module__o5gJKa__container",
  "signal": "styles-module__o5gJKa__signal",
  "visualSeparator": "styles-module__o5gJKa__visualSeparator",
});
